import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import Message, { FileMessagePayload, TextMessagePayload } from 'types/message'

const resource = 'messages'

export const requests = {
  fetchMessages: async (params: {
    roomId: number
    page: number
    limit: number
  }) => {
    return await axiosForGigbaseBiz.get<DataResponse<Message[]>>(resource, {
      params: {
        message_room_id: params.roomId,
        page: params.page,
        limit: params.limit,
      },
    })
  },
  fetchUnreadCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<{ total: number }>>(
      `${resource}/unread_count`,
    )
  },
  sendText: async (params: TextMessagePayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<Message>>(resource, {
      message_type: 'text',
      message_room_id: params.roomId,
      text: params.body,
    })
  },
  sendFile: async (params: FileMessagePayload) => {
    const formData = new FormData()
    formData.append('message_type', 'file')
    formData.append('message_room_id', params.roomId.toString())
    formData.append('file', params.file)

    return await axiosForGigbaseBiz.post<DataResponse<Message>>(
      resource,
      formData,
    )
  },
}
